import React, { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FaEnvelope, FaUsers } from 'react-icons/fa';

// This component now receives real prospects data
const RegistrationList = ({ prospects = [], onSendEmail, onSendGroupEmail }) => {
    const { i18n } = useTranslation();
    const [filters, setFilters] = useState({
        name: '',
        country: '',
        city: '',
    });

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };

    const filteredProspects = useMemo(() => {
        if (!prospects) return [];
        return prospects.filter(prospect => {
            const countryMatch = filters.country ? (prospect.pays || '').toLowerCase().includes(filters.country.toLowerCase()) : true;
            const cityMatch = filters.city ? (prospect.ville || '').toLowerCase().includes(filters.city.toLowerCase()) : true;
            const nameMatch = (
                (prospect.prenom || '').toLowerCase().includes(filters.name.toLowerCase()) || 
                (prospect.nom || '').toLowerCase().includes(filters.name.toLowerCase())
            );
            return countryMatch && cityMatch && nameMatch;
        });
    }, [prospects, filters]);

    const uniqueCountries = useMemo(() => [...new Set(prospects.map(p => p.pays))].filter(Boolean).sort(), [prospects]);
    const uniqueCities = useMemo(() => [...new Set(prospects.map(p => p.ville))].filter(Boolean).sort(), [prospects]);

    return (
        <div className="registration-list">
            <h3><FaUsers /> Liste des Prospects (depuis Formulaire de Contact)</h3>
            <div className="filter-bar" style={{ flexWrap: 'wrap', padding: '20px', gap: '15px' }}>
                <input
                    type="text"
                    name="name"
                    placeholder="Filtrer par nom/prénom..."
                    value={filters.name}
                    onChange={handleFilterChange}
                    style={{ minWidth: '200px', flexGrow: 1 }}
                />
                <select name="country" value={filters.country} onChange={handleFilterChange} style={{ minWidth: '150px' }}>
                    <option value="">Tous les pays</option>
                    {uniqueCountries.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
                <select name="city" value={filters.city} onChange={handleFilterChange} style={{ minWidth: '150px' }}>
                    <option value="">Toutes les villes</option>
                    {uniqueCities.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
            </div>
            
            <div className="table-toolbar" style={{ justifyContent: 'flex-start', marginTop: '20px', paddingLeft: '20px' }}>
                 <button onClick={() => onSendGroupEmail(filteredProspects.map(p => p.email))} className="action-btn btn-email">
                    <FaEnvelope /> Envoyer un email au groupe ({filteredProspects.length})
                </button>
            </div>

            <div className="links-table-container">
                <table>
                    <thead>
                        <tr>
                            <th>Prénom</th>
                            <th>Nom</th>
                            <th>Email</th>
                            <th>Pays</th>
                            <th>Ville</th>
                            <th>Téléphone</th>
                            <th>Date de soumission</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredProspects.map(prospect => (
                            <tr key={prospect.id}>
                                <td>{prospect.prenom}</td>
                                <td>{prospect.nom}</td>
                                <td>{prospect.email}</td>
                                <td>{prospect.pays}</td>
                                <td>{prospect.ville}</td>
                                <td>{prospect.telephone}</td>
                                <td>{new Date(prospect.date_soumission).toLocaleDateString()}</td>
                                <td className="action-cell">
                                    <button onClick={() => onSendEmail(prospect.email)} className="action-btn btn-send" title="Envoyer un email"><FaEnvelope /></button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default RegistrationList;
